<template>
  <div class="contentHome">
    <div class="centerPage">
      <div class="search-box">
        <span class="title active">新闻资讯</span>
        <router-link class="title" to="/study">每日研究</router-link>
        <router-link class="title" to="/publicWelfare">亦笙公益</router-link>
        <router-link class="title" to="/regionalResources">地区资源</router-link>
        <el-input size="mini" v-model="page.keyword" class="search" suffix-icon="el-icon-search" placeholder="搜索"
                  @change="skipPage(1)"></el-input>
      </div>
      <div class="topNews flex" style="cursor: pointer" @click="toDetails(topNews)">
        <div v-if="topNews.thumbnailPath" :style="'backgroundImage: url('+topNews.thumbnailPath+')'"
             class="listImg img"></div>
        <div v-else style="background-image:url('/static/default_imgs/news.jpg')" class="listImg img"></div>
        <div class="info">
          <h3>{{ topNews.title }}</h3>
          <p class="narrate">{{ topNews.summary }}</p>
          <p class="count">
            <span>{{ topNews.doctorName }}</span>
            <span>{{ topNews.publishDate }}</span>
            <span>{{ topNews.viewsCount }}阅读</span>
          </p>
          <el-button class="more">MORE <img src="../../assets/img/newsMore.png" alt="" width="10"></el-button>
        </div>
      </div>
      <div class="newsList">
        <div v-if="news.length==0" style="text-align: center;color: #DFE0E7;width: 100%">
          <img src="../../assets/img/empty_tips.png" alt="" style="width: 320px;">
          <div>暂无数据</div>
        </div>
        <template v-else>
          <div class="newsInfo flex" v-for="(item,index) in news" :key="index" @click="toDetails(item)">
            <div v-if="item.thumbnailPath" :style="'backgroundImage: url('+item.thumbnailPath+')'"
                 class="listImg img"></div>
            <div v-else style="background-image:url('/static/default_imgs/news.jpg')" class="listImg img"></div>
            <div class="info">
              <h4>{{ item.title }}</h4>
              <p class="narrate">{{ item.summary }}</p>
              <p class="count flex">
                <span>{{ item.doctorName }}</span>
                <span>{{ item.publishDate }}</span>
                <span>{{ item.viewsCount }}阅读</span>
                <el-button size="mini"><img src="../../assets/img/newsMore.png" alt="" width="10"></el-button>
              </p>
            </div>
          </div>
        </template>
      </div>
      <el-pagination
          v-if="news.length>0"
          class="pagination"
          background
          prev-text="Prev"
          next-text="Next"
          @size-change="handleSizeChange"
          @current-change="skipPage"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next, total"
          :total="page.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "news",
  data() {
    return {
      topNews: {},
      news: [{}],
      page: {
        keyword: '',
        page: 1,
        size: 6,
        total: 21,
      },
    }
  },
  mounted() {

    this.getData((item) => {
      if (item) {
        this.topNews = item;
      }
    });
  },
  methods: {
    getData(callback) {
      this.$ajax.get(base.api.article.information.page, {params: this.page}).then((res) => {
        if (res.data.status === 'success') {
          this.news = res.data.rows;
          this.page.page = res.data.current;
          this.page.total = res.data.total;
          this.page.size = res.data.size;
          if (callback) {
            callback(res.data.rows[0]);
          }
        }
      })
    },
    // 每页多少条
    handleSizeChange(val) {
      this.page.size = val;
    },
    // 当前页
    skipPage(current) {
      this.page.page = current;
      this.getData();
    },
    toDetails(item) {
      this.$router.push({name: 'newsDetail', query: {state: '1', id: item.id, name: item.doctorName}})
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/news.scss';
</style>

